<template>
  <div class="solution2">
    <div class="banner">
      <div class="w1200">
        <h3>农业链主企业数字化解决方案</h3>
        <p>
          通过一张网，把农业链主企业的供应商、经销商、客户集合在一张大网上,
          以链主企业为纽带，对供应链的各个环节进行数
          字化升级，打通企业内部生产和外部服务的各个环节，提升企业的效率
        </p>
      </div>
    </div>
    <div class="container">
      <img src="@/assets/mob/images/solution/c_2.jpg" alt />
    </div>
    <div class="d_footer1">
      <h3>农业链主企业数字化解决方案优势</h3>
      <van-grid :border="false" :column-num="2">
        <van-grid-item class="li">
          <div class="img"></div>
          <p>完全基于产业，产业为本， 助力产业数字化升级</p>
        </van-grid-item>
        <van-grid-item class="li">
          <div class="img"></div>
          <p>全场景覆盖</p>
        </van-grid-item>
        <van-grid-item class="li">
          <div class="img"></div>
          <p>模块化，可分期实施， 最大程度降低难度</p>
        </van-grid-item>
        <van-grid-item class="li">
          <div class="img"></div>
          <p>商流、信息流、物流、资 金流四流合一</p>
        </van-grid-item>

        <van-grid-item class="li">
          <div class="img"></div>
          <p>多仓在线，0库存管理</p>
        </van-grid-item>

        <van-grid-item class="li">
          <div class="img"></div>
          <p>多用户个性化价格方案</p>
        </van-grid-item>

        <van-grid-item class="li">
          <div class="img"></div>
          <p>多维度数据分析、智能化决策</p>
        </van-grid-item>

        <van-grid-item class="li">
          <div class="img"></div>
          <p>可对接用友和金蝶财务系统</p>
        </van-grid-item>
      </van-grid>
    </div>

    <div class="d_footer2">
      <div
        class="button"
        @click="
          show = true
          systemId = '3'
        "
      >
        获取最新解决方案
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <Dialog
      :show="show"
      :systemId="systemId"
      @close="show = false"
      title="获取最新解决方案"
    />
  </div>
</template>
<script>
import Dialog from './components/dialog'
export default {
  components: { Dialog: Dialog },
  data() {
    return {
      systemId: '3',
      show: false,
    }
  },
}
</script>
<style lang="scss">
@import '~@/assets/mob/css/solution.scss';
</style>
